var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "search-events-component",
      class: [{ mobile: _vm.mobileBigAndBelow }, _vm.routeName]
    },
    [
      _vm.eventsListProcessed && _vm.eventsListProcessed.length > 0
        ? _vm._l(_vm.eventsListProcessed, function(sporttype) {
            return sporttype.fosports && sporttype.fosports.length > 0
              ? _c(
                  "section",
                  { staticClass: "fosports" },
                  _vm._l(sporttype.fosports, function(fosport) {
                    return _c(
                      "div",
                      {
                        key: fosport.idfosport,
                        staticClass: "fosport-container"
                      },
                      [
                        _vm.routeName === "searchsport"
                          ? [
                              _c("div", { staticClass: "breadcrums_holder" }, [
                                _c("h3", [_vm._v(_vm._s(sporttype.name))]),
                                _vm._v(" "),
                                _c("span", { staticClass: "arrowright" }),
                                _vm._v(" "),
                                _c("h3", [_vm._v(_vm._s(fosport.name))])
                              ])
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        fosport &&
                        fosport.focompetitions &&
                        fosport.focompetitions.length > 0
                          ? _c(
                              "section",
                              { staticClass: "focompetitions" },
                              _vm._l(
                                fosport.focompetitions.filter(function(focomp) {
                                  return (
                                    focomp.explicitlyfound ||
                                    (focomp.events && focomp.events.length > 0)
                                  )
                                }),
                                function(focompetition) {
                                  return _c(
                                    "div",
                                    {
                                      key: focompetition.idfocompetition,
                                      staticClass: "focompetition-container"
                                    },
                                    [
                                      _vm.routeName === "searchsport"
                                        ? [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "competitiontitle clickable",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.goToFoCompetition(
                                                      focompetition
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("h3", [
                                                  _vm._v(
                                                    _vm._s(focompetition.name)
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "h3",
                                                  {
                                                    staticClass:
                                                      "viewsportcompetition"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Search.ViewMore"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.routeName === "searchcompetition"
                                        ? [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "breadcrums_holder"
                                              },
                                              [
                                                _c("h3", [
                                                  _vm._v(_vm._s(sporttype.name))
                                                ]),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "arrowright"
                                                }),
                                                _vm._v(" "),
                                                _c("h3", [
                                                  _vm._v(_vm._s(fosport.name))
                                                ]),
                                                _c("span", {
                                                  staticClass: "arrowright"
                                                }),
                                                _vm._v(" "),
                                                _c("h3", [
                                                  _vm._v(
                                                    _vm._s(focompetition.name)
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "events" }, [
                                        focompetition.events &&
                                        focompetition.events.length > 0
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "events-container"
                                              },
                                              [
                                                focompetition.events.filter(
                                                  function(ev) {
                                                    return ev.liveEvent
                                                  }
                                                ).length
                                                  ? _c("big3-markets-header", {
                                                      staticClass:
                                                        "live-header",
                                                      attrs: {
                                                        coupontitle: "",
                                                        "has-draw":
                                                          focompetition.hasdraw,
                                                        "is-big3-coupon":
                                                          focompetition.isbig3coupon,
                                                        "max-no-of-selections":
                                                          focompetition.maxnumberofselections,
                                                        idfosporttype: ""
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm._l(
                                                  focompetition.events.filter(
                                                    function(ev) {
                                                      return ev.liveEvent
                                                    }
                                                  ),
                                                  function(event, $index) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "event live",
                                                        class: [
                                                          event.idfosporttype,
                                                          {
                                                            last:
                                                              $index ===
                                                              focompetition.events.filter(
                                                                function(ev) {
                                                                  return ev.liveEvent
                                                                }
                                                              ).length -
                                                                1
                                                          }
                                                        ]
                                                      },
                                                      [
                                                        event.liveEvent
                                                          .idfosporttype &&
                                                        [
                                                          "GOLF",
                                                          "MOTORSPORT",
                                                          "NASCAR"
                                                        ].indexOf(
                                                          event.liveEvent
                                                            .idfosporttype
                                                        ) > -1
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "outright-golf outright-event-name"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                    " +
                                                                    _vm._s(
                                                                      event.name
                                                                    ) +
                                                                    "\n                  "
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            staticClass:
                                                              "wrapper"
                                                          },
                                                          [
                                                            _c(
                                                              "live-event-info",
                                                              {
                                                                attrs: {
                                                                  event:
                                                                    event.liveEvent,
                                                                  page:
                                                                    "coupon",
                                                                  threeselections:
                                                                    !focompetition.isbig3coupon &&
                                                                    focompetition.hasdraw,
                                                                  twoselections:
                                                                    !focompetition.isbig3coupon &&
                                                                    !focompetition.hasdraw,
                                                                  isbig3coupon:
                                                                    focompetition.isbig3coupon
                                                                }
                                                              }
                                                            ),
                                                            _vm._v(" "),
                                                            event.liveEvent
                                                              .markets &&
                                                            event.liveEvent
                                                              .markets.length >
                                                              0
                                                              ? _c("markets", {
                                                                  attrs: {
                                                                    markets: !focompetition.isbig3coupon
                                                                      ? [
                                                                          event
                                                                            .liveEvent
                                                                            .markets[0]
                                                                        ]
                                                                      : event
                                                                          .liveEvent
                                                                          .markets,
                                                                    event:
                                                                      event.liveEvent,
                                                                    pricechangehighlight: true,
                                                                    islivepredefined: true,
                                                                    "is-big3-coupon":
                                                                      focompetition.isbig3coupon
                                                                  }
                                                                })
                                                              : _c(
                                                                  "section",
                                                                  {
                                                                    staticClass:
                                                                      "nomarkets"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "Sports.NoAvailableMarkets"
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "live-coupon-event-footer",
                                                          {
                                                            attrs: {
                                                              event:
                                                                event.liveEvent
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                _vm._v(" "),
                                                _vm._l(
                                                  focompetition.events.filter(
                                                    function(ev) {
                                                      return !ev.liveEvent
                                                    }
                                                  ),
                                                  function(event, $index) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "event prematch",
                                                        class: [
                                                          event.idfosporttype,
                                                          {
                                                            last:
                                                              $index ===
                                                              focompetition
                                                                .events.length -
                                                                1
                                                          }
                                                        ]
                                                      },
                                                      [
                                                        $index === 0
                                                          ? _c(
                                                              "v-flex",
                                                              {
                                                                staticClass:
                                                                  "header wrapper"
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "time"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "Search.Header.Time"
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "event-name"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "Search.Header.Event"
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c("span", {
                                                                  staticClass:
                                                                    "more-markets"
                                                                })
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            staticClass:
                                                              "eventinfo wrapper clickable",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.goToEvent(
                                                                  event
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _vm.isDateToday(
                                                              event.tsstart
                                                            )
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "time"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "Search.Today"
                                                                        )
                                                                      ) +
                                                                        " " +
                                                                        _vm._s(
                                                                          _vm._f(
                                                                            "moment"
                                                                          )(
                                                                            event.tsstart,
                                                                            _vm
                                                                              .dateFormats
                                                                              .longTime
                                                                          )
                                                                        )
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _vm.isDateTomorrow(
                                                              event.tsstart
                                                            )
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "time"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "Search.Tomorrow"
                                                                        )
                                                                      ) +
                                                                        " " +
                                                                        _vm._s(
                                                                          _vm._f(
                                                                            "moment"
                                                                          )(
                                                                            event.tsstart,
                                                                            _vm
                                                                              .dateFormats
                                                                              .longTime
                                                                          )
                                                                        )
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            !_vm.isDateToday(
                                                              event.tsstart
                                                            ) &&
                                                            !_vm.isDateTomorrow(
                                                              event.tsstart
                                                            )
                                                              ? _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "time"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "moment"
                                                                        )(
                                                                          event.tsstart,
                                                                          _vm
                                                                            .dateFormats
                                                                            .longDateTime
                                                                        )
                                                                      ) + " "
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "event-name"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    event.name
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "more-markets"
                                                              },
                                                              [
                                                                _c("span", {
                                                                  staticClass:
                                                                    "arrowright"
                                                                })
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  }
                                                )
                                              ],
                                              2
                                            )
                                          : _vm._e()
                                      ])
                                    ],
                                    2
                                  )
                                }
                              ),
                              0
                            )
                          : _vm._e()
                      ],
                      2
                    )
                  }),
                  0
                )
              : _vm._e()
          })
        : _c("div", { staticClass: "no-events-found" }, [
            _vm._v("\n    " + _vm._s(_vm.$t("Search.NoEventsFound")) + "\n  ")
          ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3829aeb1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3829aeb1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/SportAndCompetitionEventsList.vue
// module id = null
// module chunks = 